import {
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemFLI,
} from '@modeso/types__aumico-lib-annualreport-be';

export interface IAddFliEvent {
    fli: IAccountMappingTemplateGroupItemFLI;
    parent: IAccountMappingTemplateGroup;
}
